import client from 'services/client'

export const updateMyInformantInfos = async (body: any) => {
  const { data }: any = await client.patch('informants', body)
  return data
}
